import React, { FC, Fragment } from "react";
import { CheckOutlined } from "@ant-design/icons";
import {
  Container,
  LabelNumberGroup,
  Number,
  Label,
  LineGuide,
} from "./elements";
import { StepsParams } from "./types";

const StepsComponent: FC<StepsParams> = (props) => {
  const { steps, current, size } = props;

  return (
    <>
      {/* <AntSteps size={size || "small"} current={current}>
        {steps.map((item: any) => (
          <StepsStyled key={item.id} title={item.title} />
        ))}
      </AntSteps> */}
      <Container>
        {steps.map((item: any, index: number) => (
          <Fragment key={index}>
            <LabelNumberGroup>
              <Number
                isActive={current === index}
                isFinished={current > index}
                size={size}
              >
                {current > index ? (
                  <CheckOutlined style={{ color: "white" }} />
                ) : (
                  index + 1
                )}
              </Number>
              <Label isActive={current === index} isFinished={current > index}>
                {item.title === "Knowledge and Skills"
                  ? size === "small"
                    ? "Skills"
                    : "Knowledge and Skills"
                  : item.title}
              </Label>
            </LabelNumberGroup>
            {steps.length - 1 > index && (
              <LineGuide isFinished={current > index} />
            )}
          </Fragment>
        ))}
      </Container>
    </>
  );
};

export default StepsComponent;
